import { CHIP_PLACEHOLDER_VARIANTS, type ChipPlaceholderVariant } from '~/features/whatsapp/constants/templatePicker';
import { cn } from '~/utils/cnTailwind';

type Props = {
    ariaLabel: string;
    onChange: (value: string) => void;
    placeholder?: string;
    placeholderVariant?: ChipPlaceholderVariant;
    value: string;
};

export const AutosizeChipInput = ({
    ariaLabel,
    onChange,
    placeholder,
    placeholderVariant = CHIP_PLACEHOLDER_VARIANTS.DEFAULT,
    value,
}: Props) => (
    <span className="rounded-md border border-[#f8e296] bg-alert-warning-bg px-1 py-px text-midnight focus-within:border-[#d4a400] relative inline-block max-w-full align-baseline">
        <span className="invisible whitespace-pre" aria-hidden>
            {value || placeholder || '\u00a0'}
        </span>
        <input
            type="text"
            aria-label={ariaLabel}
            value={value}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
            className={cn(
                'absolute inset-0 w-full border-0 bg-transparent px-1 py-px leading-5 text-midnight outline-none',
                placeholderVariant === CHIP_PLACEHOLDER_VARIANTS.ERROR
                    ? 'placeholder:text-alert-error'
                    : 'placeholder:text-midnight-placeholder',
            )}
        />
    </span>
);
